import { render, staticRenderFns } from "./pause.vue?vue&type=template&id=5c46147a&scoped=true&"
import script from "./pause.vue?vue&type=script&lang=js&"
export * from "./pause.vue?vue&type=script&lang=js&"
import style0 from "./pause.vue?vue&type=style&index=0&id=5c46147a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46147a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VIcon,VSlider})
